import { APICore, API_URL, PENSION_URL, TAX_URL } from './apiCore';
import { TaxReturnListFetchParams } from '../../interfaces/taxReturn';

const api = new APICore();

const createTaxReturn = (clientId: string, creationReason?: string) => {
    return api.create(`${TAX_URL}/tax-return`, { clientId, creationReason });
};

const editTaxReturn = (taxReturnId: string, body: any) => {
    const relativeUrl = `/tax-return/${taxReturnId}`;
    return api.update(`${TAX_URL}${relativeUrl}`, body);
};

const getTaxReturnList = (params?: TaxReturnListFetchParams) => {
    return api.get(`${TAX_URL}/tax-return/list`, params);
};

const exportTaxReturnList = (params: TaxReturnListFetchParams) => {
    const relativeUrl = '/tax-return/list/export';
    return api.getFile(`${TAX_URL}${relativeUrl}`, params);
};

const getTaxReturnStatuses = () => {
    return api.get(`${TAX_URL}/tax-return/statuses`);
};

const getTaxData = (taxDataId: string) => {
    return api.get(`${TAX_URL}/tax-data/${taxDataId}`);
};

const editTaxData = (taxDataId: string, body: any) => {
    return api.update(`${TAX_URL}/tax-data/${taxDataId}`, body);
};

const createTaxData = (taxReturnId: string) => {
    return api.create(`${TAX_URL}/tax-data/updateData`, { taxReturnId });
};

const createFilesCalculation = (taxDataId: string) => {
    return api.create(`${TAX_URL}/tax-data/sendFilesForCalculation`, {
        taxDataId,
    });
};

const getTaxReturnStatusTrackers = (params: { taxReturnId?: string; clientId?: string }) => {
    const url = `${TAX_URL}/tax-return/status-trackers`;
    return api.get(url, params);
};

export {
    getTaxReturnList,
    getTaxReturnStatuses,
    createTaxReturn,
    editTaxReturn,
    getTaxData,
    editTaxData,
    createTaxData,
    createFilesCalculation,
    exportTaxReturnList,
    getTaxReturnStatusTrackers,
};
